// Same 270° arc + indeterminate segment + spin as CaptureViewer LoadingUI (queued gauge).

import React from 'react';
import './VolugraphMiniGaugeSpinner.css';

/**
 * @param {{ className?: string, variant?: 'light' | 'dark' }} props
 *   — `dark`: light strokes on dark buttons (Pricing / Billing CTAs).
 */
export function VolugraphMiniGaugeSpinner({ className = '', variant = 'dark' }) {
  return (
    <span
      className={`volugraph-mini-gauge${variant === 'dark' ? ' volugraph-mini-gauge--on-dark' : ''}${className ? ` ${className}` : ''}`}
      aria-hidden="true"
    >
      <svg viewBox="0 0 200 200" className="volugraph-mini-gauge__svg" focusable="false">
        <circle
          className="volugraph-mini-gauge__track"
          cx="100"
          cy="100"
          r="90"
          strokeWidth="14"
          fill="none"
          transform="rotate(135 100 100)"
        />
        <circle
          className="volugraph-mini-gauge__fill"
          cx="100"
          cy="100"
          r="90"
          strokeWidth="14"
          fill="none"
          transform="rotate(135 100 100)"
        />
      </svg>
    </span>
  );
}
